import { FaBahai } from "react-icons/fa";
import { FaRoad } from "react-icons/fa";
import { FaPersonRunning } from "react-icons/fa6";
import { GoTasklist } from "react-icons/go";

export const suggestions = [
  {
    id: 1,
    title: "What is AI?",
    icon: <FaBahai />,
  },
  {
    id: 2,
    title: "Explore the Pacific Coast Highway",
    icon: <FaRoad />,
  },
  {
    id: 3,
    title: "Try an escape room challenge",
    icon: <FaPersonRunning />,
  },
  {
    id: 4,
    title: "Learn about urban planning principles",
    icon: <GoTasklist />,
  },
];
